import React from "react";
import AnimatedIntro from "../intro/Intro";
import AuthOptionsButtons from "./components/AuthOptionsButtons";
import LoginCodeInput from "../authentication/components/LoginCodeInput";
import { useLoginPage } from "./useLoginPage";
import "./Login.css";
import Intro from "../intro/Intro";

export default function Login() {
  const {
    error,
    emailForMagic,
    signUp,
    isLoading,
    successMessage,
    showCodeInput,
    introCompleted,
    
    setEmailForMagic,
    handleIntroComplete,
    sendMagicLink,
    handleCodeVerified,
    handleBackToEmail,

    isOnline,
    loadingStates,
  } = useLoginPage();

  if (!introCompleted) {
    return <AnimatedIntro onComplete={handleIntroComplete} />;
  }

  return (
    <>
      {!localStorage.getItem("isIntroSeen") && (
        <Intro onComplete={undefined} />
      )}
      {!signUp ? (
        <div>
          <div>
            {error && !showCodeInput && (
              <div className="auth-error-message">{error}</div>
            )}
            {successMessage && !showCodeInput && (
              <div className="auth-success-message">{successMessage}</div>
            )}

            <div>
              {showCodeInput ? (
                <LoginCodeInput
                  email={emailForMagic}
                  onCodeVerified={handleCodeVerified}
                  onBack={handleBackToEmail}
                  isLoading={isLoading}
                  isOnline={isOnline}
                />
              ) : (
                <AuthOptionsButtons
                  email={emailForMagic}
                  onEmailChange={setEmailForMagic}
                  onSubmit={sendMagicLink}
                  isLoading={isLoading}
                  isOnline={isOnline}
                  loadingStates={loadingStates}
                />
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
